const EsimIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0306 7.71938L14.7806 2.46938C14.7109 2.39975 14.6282 2.34454 14.5371 2.3069C14.4461 2.26926 14.3485 2.24992 14.25 2.25H5.25C4.85218 2.25 4.47064 2.40804 4.18934 2.68934C3.90804 2.97064 3.75 3.35218 3.75 3.75V20.25C3.75 20.6478 3.90804 21.0294 4.18934 21.3107C4.47064 21.592 4.85218 21.75 5.25 21.75H18.75C19.1478 21.75 19.5294 21.592 19.8107 21.3107C20.092 21.0294 20.25 20.6478 20.25 20.25V8.25C20.2501 8.15148 20.2307 8.05391 20.1931 7.96286C20.1555 7.87182 20.1003 7.78908 20.0306 7.71938ZM18.75 20.25H5.25V3.75H13.9397L18.75 8.56031V20.25ZM16.5 10.5H7.5C7.30109 10.5 7.11032 10.579 6.96967 10.7197C6.82902 10.8603 6.75 11.0511 6.75 11.25V18C6.75 18.1989 6.82902 18.3897 6.96967 18.5303C7.11032 18.671 7.30109 18.75 7.5 18.75H16.5C16.6989 18.75 16.8897 18.671 17.0303 18.5303C17.171 18.3897 17.25 18.1989 17.25 18V11.25C17.25 11.0511 17.171 10.8603 17.0303 10.7197C16.8897 10.579 16.6989 10.5 16.5 10.5ZM15.75 17.25H14.25V14.25C14.25 14.0511 14.171 13.8603 14.0303 13.7197C13.8897 13.579 13.6989 13.5 13.5 13.5C13.3011 13.5 13.1103 13.579 12.9697 13.7197C12.829 13.8603 12.75 14.0511 12.75 14.25V17.25H11.25V14.25C11.25 14.0511 11.171 13.8603 11.0303 13.7197C10.8897 13.579 10.6989 13.5 10.5 13.5C10.3011 13.5 10.1103 13.579 9.96967 13.7197C9.82902 13.8603 9.75 14.0511 9.75 14.25V17.25H8.25V12H15.75V17.25Z"
        fill="#424242"
      />
    </svg>
  );
};

export default EsimIcon;
